import "./CountryHero.css"

const CountryHero = ({ country, flagUrl, heroImage }) => {
  return (
    <div
      className="country-hero"
      style={{
        backgroundImage: `url(${heroImage})`,
      }}
    >
      <div className="hero-content">
        <div className="country-flag-title">
          <img
            src={flagUrl || "https://cdn-icons-png.flaticon.com/128/197/197374.png"}
            alt={`${country} Flag`}
            className="country-flag"
          />
          <h1>Study in {country}</h1>
        </div>
        <a href="#contact" className="cta-button">
          Talk to an Expert Counsellor for FREE
        </a>
      </div>
    </div>
  )
}

export default CountryHero
